<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <div class="separador-secao">
          <h3 class="side-bar-seperator">GERAL</h3>
          <sidebar-item :link="{ name: 'Dashboard', path: '/dashboard' }" />
        </div>

        <div class="separador-secao nbt">
          <h3 class="side-bar-seperator">CLIENTES</h3>
          <sidebar-item
            :link="{
              name: 'Lista de Clientes',
              path: '/clientes/lista-clientes',
            }"
          />
          <sidebar-item
            :link="{ name: 'Grupos de Clientes', path: '/clientes/segmentos' }"
          />
          <sidebar-item
            v-if="!isStaff"
            :link="{ name: 'Gestor de Descontos', path: '/clientes/descontos' }"
          />
          <sidebar-item
            :link="{
              name: 'Mensagens de Clientes',
              path: '/clientes/whatsapp',
            }"
          />
        </div>

        <!-- Campanhas — owner e manager vêem, staff não -->
        <div v-if="!isStaff" class="separador-secao">
          <h3 class="side-bar-seperator">CAMPANHAS</h3>
          <sidebar-item
            :link="{ name: 'Criar Campanhas', path: '/campanhas/criar' }"
          />
          <sidebar-item
            :link="{ name: 'Gerir Templates', path: '/campanhas/templates' }"
          />
          <sidebar-item
            :link="{
              name: 'Histórico de Campanhas',
              path: '/campanhas/historico',
            }"
          />
        </div>

        <div class="separador-secao">
          <h3 class="side-bar-seperator">INSIGHTS</h3>
          <sidebar-item :link="{ name: 'Ver Insights', path: '/insights' }" />
          <sidebar-item
            :link="{ name: 'Estatísticas Mensais', path: '/estatisticas' }"
          />
        </div>

        <!-- Definições — owner e manager vêem, staff não -->
        <div v-if="!isStaff" class="separador-secao">
          <h3 class="side-bar-seperator">DEFINIÇÕES</h3>
          <sidebar-item
            :link="{ name: 'Tipo de Clientes', path: '/definicoes' }"
          />
          <sidebar-item
            :link="{ name: 'Categorias de Produto', path: '/categorias' }"
          />
          <sidebar-item
            v-if="isOwner"
            :link="{ name: 'Restaurantes', path: '/restaurantes' }"
          />
          <sidebar-item :link="{ name: 'Gestão de Equipa', path: '/staff' }" />
        </div>

        <div class="separador-secao">
          <sidebar-item
            :link="{
              name: 'Terminar Sessão',
              path: '#',
              icon: 'ni ni-user-run text-red',
            }"
            @click.native="logout"
          />
        </div>
      </template>
    </side-bar>

    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
  import PerfectScrollbar from "perfect-scrollbar";
  import "perfect-scrollbar/css/perfect-scrollbar.css";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }
  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      setTimeout(() => initScrollbar(className), 100);
    }
  }

  import DashboardNavbar from "./DashboardNavbar.vue";
  import ContentFooter from "./ContentFooter.vue";
  import { FadeTransition } from "vue2-transitions";
  import api from "@/api/index.js";

  export default {
    components: { DashboardNavbar, ContentFooter, FadeTransition },

    computed: {
      currentUser() {
        return JSON.parse(localStorage.getItem("user") || "{}");
      },
      isOwner() {
        return this.currentUser.role === "owner" || !this.currentUser.role;
      },
      isManager() {
        return this.currentUser.role === "manager";
      },
      isStaff() {
        return this.currentUser.role === "staff";
      },
    },

    methods: {
      logout() {
        localStorage.removeItem("tokenAbitue");
        localStorage.removeItem("user");
        this.$router._setupChecked = false;
        this.$router._temRestaurantes = false;
        this.$router.push("/login");
      },
      initScrollbar() {
        if (navigator.platform.startsWith("Win")) initScrollbar("sidenav");
      },
      async sincronizarRole() {
        try {
          const { data } = await api.get("/auth/me");
          if (data?.user) {
            const userAtual = JSON.parse(localStorage.getItem("user") || "{}");
            // Se o role mudou, atualizar localStorage e forçar re-render
            if (userAtual.role !== data.user.role) {
              localStorage.setItem(
                "user",
                JSON.stringify({ ...userAtual, ...data.user }),
              );
              // Forçar re-render do menu
              this.$forceUpdate();
            }
          }
        } catch (err) {
          // Se 401/403, fazer logout
          if (err.response?.status === 401 || err.response?.status === 403) {
            this.logout();
          }
        }
      },
    },

    mounted() {
      this.initScrollbar();
      this.sincronizarRole();
    },
  };
</script>

<style lang="scss"></style>
